"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RolesSubjectToSanctionScreeningRef = void 0;
const Field_type_1 = require("../../types/Field.type");
exports.RolesSubjectToSanctionScreeningRef = {
    priority: Number.MAX_VALUE,
    label: 'fields.enm.roles_subject_to_sanction_screening.label',
    fallbackLabel: 'Roles subject to sanction screening',
    type: Field_type_1.FieldType.Enum,
    options: [
        { key: 'MERCHANTS_ENTITY', label: 'fields.enm.roles_subject_to_sanction_screening.options.MERCHANTS_ENTITY', fallbackLabel: 'The merchant\'s entity' },
        { key: 'ULTIMATE_BENEFICIAL_OWNERS', label: 'fields.enm.roles_subject_to_sanction_screening.options.ULTIMATE_BENEFICIAL_OWNERS', fallbackLabel: 'Ultimate Beneficial Owners' },
        { key: 'AUTHORIZED_SIGNATORIES', label: 'fields.enm.roles_subject_to_sanction_screening.options.AUTHORIZED_SIGNATORIES', fallbackLabel: 'Authorized signatories' },
        { key: 'OTHER', label: 'fields.enm.roles_subject_to_sanction_screening.options.OTHER', fallbackLabel: 'Other' },
        { key: 'NONE', label: 'fields.enm.roles_subject_to_sanction_screening.options.NONE', fallbackLabel: 'We do not perform sanction screening on either of them' },
    ],
    trackFieldValueWithAnalytics: false,
};
